<template>
    <div v-if="buildingProcessedId > 0 && storedAccount" class="userWrapper">
        <div class="users mb-ss-4 d-flex justify-content-center justify-content-lg-end">
            <div>
                <div class="userIcons">
                    <template v-for="(user,index) in buildingUsers">
                        <a href="javascript:void(0)" class="nameInitialsCircle"
                           v-if="user.user && index < 4"
                           v-bind:class="{'nameInitialsCircleSelf': user.user.uuid && user.user.uuid === $store.getters.firebaseUser.uid}"
                           @click="
                                showSingleUserCardInfo(user,index);
                                showAllUserCard = false
                                showAddUserCard = false
                                ">
                            <ToolTip>
                                    <p class="userInitials"
                                       data-toggle="tooltip"
                                       data-placement="top"
                                       title = ""
                                       :data-original-title = "userTitle(user)"
                                    >
                                        {{tools.userInitial(user.user)}}
                                    </p>
                            </ToolTip>
                        </a>
                    </template>

                    <a href="javascript:void(0)" class="nameInitialsCircle totalUsers" v-if="buildingUsers.length > 4"
                       @click="
                            showAllUserCard = !showAllUserCard
                            showAddUserCard = false
                            isClickedUserId = undefined
                            isEditUserMode=undefined
                ">
                        <p class="userInitials">+{{totalUsers}}</p></a>
                </div>
                <div class="inviteUser">
                    <div class="inviteUser-split"></div>
                    <div class="inviteUser-usersIcon"><i class="fas fa-users usersIcon"></i></div>
                    <ToolTip>
                        <template v-if="canAdd">
                            <button v-if="buildingRoles.length > 0" type="button" class="inviteUser-button btn btn-sm"
                                    data-toggle="tooltip"
                                    data-placement="left"
                                    title=""
                                    data-original-title ="Send an invitation email to a new user or include existing user."
                                    @click="
                                            showAddUserCard = !showAddUserCard
                                            showAllUserCard = false
                                            isClickedUserId = undefined
                                            isEditUserMode=undefined
                                           "
                                     >
                                        Invite
                            </button>
                            <button v-else type="button" class="inviteUser-button btn btn-sm" disabled
                                    tabindex="0"
                                    data-toggle="tooltip"
                                    data-placement="left"
                                    title=""
                                    data-original-title ="You do not have permission to invite users. Please contact the building administrator to invite a user."
                            >
                                 <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Invite
                            </button>
                        </template>
                        <template v-else>
                            <div class="inviteUser-button btn btn-sm disabled"
                                    data-toggle="tooltip"
                                    data-placement="left"
                                    title=""
                                    data-original-title ="You do not have permission to invite users. Please contact the building administrator to invite a user."
                            >
                                Invite
                            </div>
                        </template>
                    </ToolTip>
                </div>
            </div>
        </div>
        <ShowSingleUserCard
                v-if="isClickedUserId || isClickedUserId === null"
                :user="user"
                :title="title"
                :users="buildingUsers"
                :index="index"
                :buildingRole="buildingRole"
                :buildingId="buildingId"
                @close = "isClickedUserId = undefined"
        >
        </ShowSingleUserCard>
        <ShowAllUsers
                v-if="showAllUserCard"
                :users="buildingUsers"
                :buildingRoles="buildingRoles"
                :buildingId="buildingId"
                @updateUsers="$emit('refetchUsers')"
                @close="showAllUserCard=false;"
        >
        </ShowAllUsers>
        <AddUserCard
                v-if="showAddUserCard"
                :buildingRoles="buildingRoles"
                :buildingId="buildingId"
                @updateUsers="$emit('refetchUsers')"
                @close="showAddUserCard=false"
        >
        </AddUserCard>
        <EditUserCard v-if="isEditUserMode"
                      :buildingRole="buildingRole"
                      :buildingId="buildingId"
                      :buildingRoles="buildingRoles"
                      :index="index"
                      :users="buildingUsers"
                      :title="title"
                      :user="user"
                      :isPatchMode="isEditUserPatchMode"
                      @updateUsers="$emit('refetchUsers')"
                      @close="isEditUserMode=undefined;"
        >
        </EditUserCard>
    </div>
</template>
<script>
import AddUserCard from '@/components/building-management/users/AddUserCard.vue';
import ShowAllUsers from '@/components/building-management/users/ShowAllUsers.vue';
import ShowSingleUserCard from '@/components/building-management/users/ShowSingleUserCard.vue';
import EditUserCard from '@/components/building-management/users/EditUserCard.vue';
import Tools from '@/app-model/tools.js';
import User from '@/app-model/user.js';
import Building from '@/app-model/building.js';

import ToolTip from '@/components/tool-tip/ToolTip.vue';

function initialData() {
    return {
      showSingleUserCard: false,
      isEditUserMode: undefined,
      isEditUserPatchMode: undefined,
      isClickedUserId: undefined,
      showAddUserCard: false,
      showAllUserCard: false,
      buildingRoles: [],
      user: {},
      title: undefined,
      index: undefined,
      buildingRole: {},
    }
  }

  export default {
    props: {
      buildingRoleName: String,
      users: Array,
      buildingId: [String, Number]
    },
    data () {
      return initialData();
    },
    components: {
      AddUserCard,
      ShowAllUsers,
      ShowSingleUserCard,
      EditUserCard,
      ToolTip
    },

    mounted () {
      this.fetchBuildingRoles(this.buildingId);
    },

    methods: {
      showSingleUserCardInfo: function (user,index) {
        this.isClickedUserId = this.isClickedUserId === user.user.id ? undefined : user.user.id;
        this.isEditUserMode = undefined;
        this.isEditUserPatchMode = undefined;
        this.index = index;
        this.buildingRole = user.building_role;
        this.user = user.user;
        this.title = user.title;
      },

      editUser: function (user, title) {
        this.isClickedUserId = undefined;
        this.isEditUserMode = this.isClicked === user.id ? undefined : user.id;
        this.isEditUserPatchMode = false;
        this.user = user;
        this.title = title;
      },

      patchUser: function (user, title) {
        this.isClickedUserId = undefined;
        this.isEditUserMode = this.isClicked === user.id ? undefined : user.id;
        this.isEditUserPatchMode = true;
        this.user = user;
        this.title = title;
      },


      userTitle: function (user) {
        let {title = '', user: {name: username = ''}, building_role: {name: building_role_name = '', display_name: building_role_display_name = ''}} = user,
            text = '';
        if (title.toLowerCase() === building_role_name.toLowerCase()) {
          text = `${title}: ${username}`;
        }
        else {
          text = `${title}: ${username} (${building_role_display_name})`;
        }
        return text.replace(/^\:/, '').trim();
      },
      fetchBuildingRoles (buildingId) {
        this.buildingModel.fetchBuildingRoles({buildingId, store: this.$store}).then(response => {
          if (response.status === 200 && buildingId === this.buildingId) {
            this.buildingRoles = response.data.data;
            this.buildingModel.formatBuildingRoles(this.buildingRoles);
          }
        });
      },
    },
    computed: {
      tools: function() {
        return new Tools;
      },
      userModel: function() {
        return new User;
      },
      buildingModel: function() {
        return new Building;
      },
      buildingProcessedId: function () {
        return this.buildingId;
      },
      storedAccount: function() {
        return this.$store.getters.firebaseUser;
      },
      /**
       * @return {boolean}
       */
      canAdd () {
        return this.userModel.canAddUserBuildingRole({store: this.$store, buildingId: this.buildingProcessedId});
      },
      totalUsers: function () {
        return this.buildingUsers.length - 4
      },
      buildingUsers () {
        let { data = [] } = this.users;

        for(let i = 0; i < data.length; i++) {
          data[i].building_role.display_name = this.tools.ucfirst(data[i].building_role.display_name);
          data[i].title = this.tools.ucfirst(data[i].title);
          data[i].user.userInitial = this.tools.userInitial(data[i].user);
        }

        data = data.filter(item => {
          return !!item.user
        });

        let selfIndex = data.findIndex(item => item.user.uuid === this.$store.getters.firebaseUser.uid);

        if(selfIndex > -1) {
          let self = data[selfIndex];
          data.splice(selfIndex, 1);
          data.unshift(self);
        }

        return data;
      }
    }
  }
</script>
<style lang="scss" scoped>
    @import "@/../sass/_users.scss";
</style>